module.exports = __webpack_public_path__ + "static/banner2-6d134e720a28ccff0531fe20746ff7c2.png";